/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./toolbarMenu.vue?vue&type=template&id=66c89c96&scoped=true"
import script from "./toolbarMenu.vue?vue&type=script&lang=js"
export * from "./toolbarMenu.vue?vue&type=script&lang=js"
import style0 from "./toolbarMenu.vue?vue&type=style&index=0&id=66c89c96&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66c89c96",
  null
  
)

export default component.exports